import {
  type Event as CalendarEvent,
} from '@pique/core/tauri/plugins/db';
import { LiveData, Service } from '@toeverything/infra';

// TODO: Update this to handle all of google calendar sync
export class CalendarService extends Service {
  public readonly calendarAccess$ = new LiveData<boolean>(false);
  public readonly calendarEvents$ = new LiveData<CalendarEvent[]>([]);
  public readonly selectedEvents$ = new LiveData<string[]>([]);

  constructor() {
    super();
  }

  public toggleEventSelection(eventId: string): void {
    const currentSelected = this.selectedEvents$.value;
    let newSelected: string[];

    if (currentSelected.includes(eventId)) {
      newSelected = currentSelected.filter((id: string) => id !== eventId);
    } else {
      newSelected = [...currentSelected, eventId];
    }

    this.selectedEvents$.next(newSelected);
  }

  public isEventSelected(eventId: string): boolean {
    return this.selectedEvents$.value.includes(eventId);
  }

  public getSelectedEvents(): CalendarEvent[] {
    const selectedIds = this.selectedEvents$.value;
    return this.calendarEvents$.value.filter((event: CalendarEvent) =>
      selectedIds.includes(event.id)
    );
  }
}
